import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
  import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
  ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


  const AdminOverview = () => 
  {

    const [data, setData] = useState([]);
  const [insightData, setInsightData] = useState([])
   
  useEffect(()=>{

    const responseData = [
      { month: 'Jan', customer: 40, employee: 65, partner: 85, investor: 150 },
      { month: 'Feb', customer: 15, employee: 20, partner: 10, investor: 125 },
      { month: 'Mar', customer: 120, employee: 125, partner: 15, investor: 130 },
      { month: 'Apr', customer: 125, employee: 130, partner: 120, investor: 135 },
      { month: 'May', customer: 130, employee: 125, partner: 125, investor: 140 },
      { month: 'Jun', customer:135, employee: 220, partner: 230, investor: 145 },
      { month: 'Jul', customer: 110, employee: 135, partner: 135, investor: 150 },
      { month: 'Aug', customer: 155, employee: 140, partner: 40, investor: 55 },
      { month: 'Sep', customer: 90, employee: 215, partner: 145, investor: 60 },
      { month: 'Oct', customer: 155, employee: 180, partner: 50, investor: 65 },
      { month: 'Nov', customer: 160, employee: 155, partner: 55, investor: 70 },
      { month: 'Dec', customer: 165, employee: 140, partner: 160, investor: 75 },
    ];
    setInsightData(responseData)

  },[])
  const colors = {
    customer: '#FF6384',  // Example color, replace with actual color from the image
    employee: '#36A2EB',  // Example color, replace with actual color from the image
    partner: '#FFCE56',   // Example color, replace with actual color from the image
    investor: '#4BC0C0'   // Example color, replace with actual color from the image
  };
    // const formattedChartData = marketGraphData.length > 0 ? preprocessMarketData(marketGraphData, selectedRange) : [];

    const chartData = {
      labels: insightData.map((label)=>label.month) ,
      datasets: [
          {
              label: "Customer",
              data:insightData.map((data)=>data.customer),
              borderColor: colors.customer,
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              fill: false,
              tension: 0.3,
              borderWidth: 1.5,
              pointBackgroundColor: 'white',
              pointBorderColor: '#000000',
              pointRadius: 0,
              pointHoverRadius: 3,
              hoverRadius: 3,
              // xAxisID: 'x',  
          },
          
          {
              label: "Employee",
              data:insightData.map((data)=>data.customer),
              borderColor: colors.employee,
              // borderDash: [3, 3],
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              fill: false,
              tension: 0.3,
              borderWidth: 1.5,
              pointBackgroundColor: 'white',
              pointBorderColor: '#000000',
              pointRadius: 0,
              pointHoverRadius: 3,
              hoverRadius: 3,
              // yAxisID: 'y',  
          },
          {
            label: "Partner",
            data:insightData.map((data)=>data.partner),
            borderColor: colors.partner,
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            fill: false,
            tension: 0.3,
            borderWidth: 1.5,
            pointBackgroundColor: 'white',
            pointBorderColor: '#4BC0C0',
            pointRadius: 0,
            pointHoverRadius: 3,
            hoverRadius: 3,
            // yAxisID: 'y1', // Adjust if using a different axis
          },
          {
            label: "Investor",
            data:insightData.map((data)=>data.investor),

            borderColor: colors.investor,
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            fill: false,
            tension: 0.3,
            borderWidth: 1.5,
            pointBackgroundColor: 'white',
            pointBorderColor: '#4BC0C0',
            pointRadius: 0,
            pointHoverRadius: 3,
            hoverRadius: 3,
            // yAxisID: 'y1', // Adjust if using a different axis
          }
        
      ],
  };
  
  

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    hover: {
        mode: 'index',
        intersect: false,
    },
    scales: {
        y: {
            type: 'linear',
            position: 'left',  
            ticks: {
                callback: function (value) {
                  return value.toFixed(2) + '%'; 
                },
                stepSize: 50,  
                min: 0,  
                max: 250, 
                font: {
                    size: 10,
                },
                padding: 10
            },
            grid: {
                borderColor: '#dddddd',
                borderWidth: 0.1,
                drawTicks: false,
                lineWidth: 0.4,
            },
            border: {
                color: '#dddddd',
                width: 0
            }
        },
        // y1: {  
        //     type: 'linear',
        //     position: 'right', 
        //     ticks: {
        //         callback: function (value) {
        //           return value.toFixed(2); 
        //         },
        //         stepSize: 50,  
        //         min: 0,  
        //         max: 250,  
        //         font: {
        //             size: 10,
        //         },
        //         padding: 10
        //     },
        //     grid: {
        //         borderColor: '#dddddd',
        //         borderWidth: 0.1,
        //         drawTicks: false,
        //         lineWidth: 0.4,
        //     },
        //     border: {
        //         color: '#dddddd',
        //         width: 0
        //     }
        // },
        x: {
            ticks: {
                font: {
                    size: 10,
                },
                padding: 15
            },
            grid: {
                borderColor: '#dddddd',
                borderWidth: 0.1,
                drawTicks: false,
                lineWidth: 0.4,
            },
            border: {
                color: '#dddddd',
                width: 0
            }
        },
    },
    plugins: {
      legend: {
        display: false,
        position: 'top',
        labels: {
          usePointStyle: false  ,
          pointStyle: 'linear',
          padding: 20,
          color: '#000',  // Adjust text color if needed
        }
      },
        tooltip: {
            mode: 'index',
            intersect: true,
            backgroundColor: '#FFFFFF',
            borderColor: '#E5E5E5',
            borderWidth: 1,
            titleFont: {
                size: 12,
                weight: 'bold',
            },
            titleColor: '#333',
            bodyFont: {
                size: 12,
            },
            bodyColor: '#333',
            displayColors: false,
            padding: 10,
            callbacks: {
                label: function (context) {
                    let label = context.dataset.label || '';
                    let value = context.raw;

                    if (label === "Customer") {
                      return `${label}: ${value.toFixed(2)}%`; 
                    } else {
                      return `${label}: ${value.toFixed(2)}`;  
                    }
                },
                labelTextColor: function (context) {
                    if (context.dataset.label === "Partner") {
                        return '#FF8400';
                    } else {
                        return '#333';
                    }
                },
                title: function () {
                    return '';
                },
            },
        },
    },
};

    const baseClass = 'container-fluid';
 
    return (
      
      <div className={`${baseClass}`}>

        <div className="d-sm-flex align-items-center justify-content-between mb-2 h_title">
          <h1 className="dashboard_heading">Overview</h1>
        </div>

        {/* <div className="overview_box">

          <div className="box">
            <div className="view_box">
              <div className="total_num">
                <p className="box_heading">Customer</p>
                <h4 className="num_title">87</h4>
              </div>
              <div className="green_box">
              </div>
              <div className="box_icon">
                <img src="img/quantity.svg" alt="" />
              </div>
            </div>
          </div>

          <div className="box">
            <div className="view_box">
              <div className="total_num">
                <p className="box_heading">Employee</p>
                <h4 className="num_title">66</h4>
              </div>
            
              <div className="box_icon">
                <img src="img/quantity.svg" alt="" />
              </div>
            </div>
          </div>

          <div className="box">
            <div className="view_box">
              <div className="total_num">
                <p className="box_heading">Partner</p>
                <h4 className="num_title">44</h4>
              </div>
            
              <div className="box_icon">
                <img src="img/quantity.svg" alt="" />
              </div>
            </div>
          </div>

          <div className="box">
            <div className="view_box">
              <div className="total_num">
                <p className="box_heading">Investor</p>
                <h4 className="num_title">55</h4>
              </div>
            
              <div className="box_icon">
                <img src="img/quantity.svg" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="right_wrapper top_space">
          <div className="split d-flex justify-content-around">

          <div className="graph_view border_line">
            <div className="graph_years d-flex justify-content-between align-items-baseline">
              <div className="title_graph">
                  <p className="dashboard_title black_txt">Response Insights</p>
              </div>
           </div>

          <div className="chart-area " style={{ height: '300px', width:'100%' }}>
              <Line data={chartData} options={chartOptions} />
          </div>

          <div className="legend_lable">
              <div className="label_title">
                  <div className="label_1">
                      <span className="color_line"></span>
                      <p>Customer</p>
                  </div>
                  <div className="label_2">
                      <span className="color_line"></span>
                      <p>Employee</p>
                  </div>
                  <div className="label_3">
                      <span className="color_line"></span>
                      <p>Partner</p>
                  </div>
                  <div className="label_4">
                      <span className="color_line"></span>
                      <p>Investor</p>
                  </div>
              </div>
          </div>
      </div>

          </div>
        </div>  */}

       

      </div>
    );
  };

  export default AdminOverview;
